interface PpHeaderTextProps {
  isApproved: boolean;
}

const PpHeaderText = ({ isApproved }: PpHeaderTextProps) => {
  if (isApproved) {
    return (
      <p>
        To ensure consistency in evaluations, all schemes currently evaluating
        or considering evaluation of products compliant with NIAP-approved
        Protection Profiles (PP) should notify niap@niap-ccevs.org. The
        notification should include the product name, vendor, evaluation start
        date, and NIAP-approved PP/EP with which compliance is being claimed.
        NIAP will collaborate with the scheme to address questions, provide
        guidance, and solicit feedback for improvements to the PPs.
      </p>
    );
  }

  return (
    <p>
      Protection Profiles (PPs) listed on this page are for reference only and
      are not to be used as the basis for new evaluations in NIAP. PPs are
      reviewed periodically to determine if the security functional and
      assurance requirements are still acceptable, given rapid technology
      changes and increasing threat levels.
    </p>
  );
};

export default PpHeaderText;
